<template>
  <div role="grid" :is="tag" :class="[baseCss]" aria-readonly="true">
    <slot />
  </div>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'Flex',
  mixins: [
    methods
  ],
  data () {
    return {
      baseCss: this.componentBaseCss('flex')
    }
  },
  props: {
    tag: {
      type: String,
      default: 'section'
    },
    spacing: {
      type: Number,
      default: 0,
      validator (value) {
        if (value < 0) {
          return false
        }
        return true
      }
    }
  }
}
</script>
<style>
.bcq-flex,
.bcq-flex *
{
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

.bcq-flex
{
  flex-wrap: wrap;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-flex: 1;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  -ms-flex-wrap: nowrap;
  margin: auto;
  width: 100%;
}

.bcq-flex:only-child
{
  margin: -4px;
}
</style>



// WEBPACK FOOTER //
// src/bcq-ui/components/flex/flex.vue